import { PaginationState } from '@tanstack/react-table';

import { Pagination } from '../../../types';
import { DEFAULT_PAGINATION } from '../constants/defaults';

export const convertReactTablePaginationStateToPagination = (
  paginationState: PaginationState,
): Pagination => ({
  page: paginationState.pageIndex + 1,
  perPage: paginationState.pageSize,
});

export const convertPaginationToReactTablePaginationState = (
  pagination?: Pagination,
): PaginationState => ({
  pageIndex: (pagination?.page ?? DEFAULT_PAGINATION.page) - 1,
  pageSize: pagination?.perPage ?? DEFAULT_PAGINATION.perPage,
});
